
export const SET_CANDIDATE_LIST_FOR_JOB_POSITION = 'app/SET_CANDIDATE_LIST_FOR_JOB_POSITION';
export const SET_SELECTED_CANDIDATE_FOR_JOB_POSITION = 'app/SET_SELECTED_CANDIDATE_FOR_JOB_POSITION';
